import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://wip.fibrebondindustries.com:5050/api', // ✅ Notice /api
  // baseURL: 'https://localhost:5050/api', // ✅ Notice /api
  // headers: {
  //   'Content-Type': 'application/json',
  // },
});

export default axiosInstance;
